/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Llm_Provider_HelpInputs */

const en_llm_provider_help = /** @type {(inputs: Llm_Provider_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the AI model used to analyze video and generate AD scripts.`)
};

const fr_llm_provider_help = /** @type {(inputs: Llm_Provider_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez le modèle d'IA utilisé pour analyser la vidéo et générer les scripts publicitaires.`)
};

const de_llm_provider_help = /** @type {(inputs: Llm_Provider_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie das KI-Modell aus, das zur Videoanalyse und zur Generierung von Werbeskripten verwendet wird.`)
};

const it_llm_provider_help = /** @type {(inputs: Llm_Provider_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il modello di intelligenza artificiale da utilizzare per analizzare il video e generare gli script degli annunci pubblicitari.`)
};

const ru_llm_provider_help = /** @type {(inputs: Llm_Provider_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите модель ИИ, используемую для анализа видео и генерации рекламных сценариев.`)
};

const es_llm_provider_help = /** @type {(inputs: Llm_Provider_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el modelo de IA utilizado para analizar el vídeo y generar los guiones publicitarios.`)
};

const zh_cn2_llm_provider_help = /** @type {(inputs: Llm_Provider_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择用于分析视频和生成广告脚本的AI模型。`)
};

const ja_llm_provider_help = /** @type {(inputs: Llm_Provider_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画を分析して広告スクリプトを生成するために使用するAIモデルを選択してください。`)
};

const hi_llm_provider_help = /** @type {(inputs: Llm_Provider_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो का विश्लेषण करने और विज्ञापन स्क्रिप्ट तैयार करने के लिए उपयोग किए जाने वाले एआई मॉडल का चयन करें।`)
};

const pt_pt2_llm_provider_help = /** @type {(inputs: Llm_Provider_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o modelo de IA usado para analisar o vídeo e gerar os roteiros dos anúncios.`)
};

/**
* | output |
* | --- |
* | "Select the AI model used to analyze video and generate AD scripts." |
*
* @param {Llm_Provider_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const llm_provider_help = /** @type {((inputs?: Llm_Provider_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Llm_Provider_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_llm_provider_help(inputs)
	if (locale === "de") return de_llm_provider_help(inputs)
	if (locale === "it") return it_llm_provider_help(inputs)
	if (locale === "ru") return ru_llm_provider_help(inputs)
	if (locale === "es") return es_llm_provider_help(inputs)
	if (locale === "zh-CN") return zh_cn2_llm_provider_help(inputs)
	if (locale === "ja") return ja_llm_provider_help(inputs)
	if (locale === "hi") return hi_llm_provider_help(inputs)
	if (locale === "pt-PT") return pt_pt2_llm_provider_help(inputs)
	return en_llm_provider_help(inputs)
});